import { SeverityTranslation } from 'api'
import { Translation } from 'locale'
import React from 'react'
import { RadioButtonStrip } from 'view/components/buttons'
import { LogLevelComponentContainer } from '../ClientLogStreamScreen.styled'

interface LogLevelComponentProps {
  label: string
  value: SeverityTranslation
  onChange: (v: SeverityTranslation) => void
  dataTestId?: string
}

export const LogLevelComponent: React.FC<LogLevelComponentProps> = ({ label, value, dataTestId, onChange }) => (
  <LogLevelComponentContainer {...(dataTestId && { ['data-test-id']: `${dataTestId}-loglevel` })}>
    <span>{label}</span>
    <RadioButtonStrip
      dataTestId={label.toLowerCase().replace(/\s/, '-')}
      onUpdate={onChange}
      selectedOption={value}
      options={[
        Translation.TC_CLIENT_LOGSTREAM_SEVERITY_NONE,
        Translation.TC_CLIENT_LOGSTREAM_SEVERITY_INFO,
        Translation.TC_CLIENT_LOGSTREAM_SEVERITY_WARN,
        Translation.TC_CLIENT_LOGSTREAM_SEVERITY_ERROR
      ]}
    />
  </LogLevelComponentContainer>
)
